import React from 'react'
import Template from '../../containers/Template'
import { TemplateType } from '../Routes'
import { giveConsent } from '../../containers/Cookies/cookiesManager'
import { markCookiesVersion } from '../../containers/Cookies/cookieVersion'
import { storeCookies } from '../../containers/Cookies/storage'

const v2 = [
  '/statistics/overview',
  'price/configuration',
  'premium',
  '/integration/booking',
  '/dev',
]

function WithTemplate<P>(Component: {
  C: React.ComponentType<P>
  scope: any
  template: TemplateType
}) {
  return {
    C: (props: any) => {
      const isv2 =
        v2.some(v => props.location.pathname.includes(v)) ||
        Component.template === TemplateType.New

      if (String(props.mobile) === '1') {
        const nextCookies = {
          necessary: true,
          functional: false,
          analytics: false,
          performance: false,
          advertisement: false,
        }
        storeCookies(nextCookies)
        try {
          localStorage.setItem('cookies', JSON.stringify(nextCookies))
        } catch (e) {}
        markCookiesVersion()

        giveConsent()

        return (
          <div
            style={{
              height: 'var(--full)',
              overflowY: 'auto',
              width: '100%',
            }}
          >
            {/*<CookieModalWrapper/>*/}
            <Component.C mobile={true} {...props} />
          </div>
        )
      }

      return (
        <Template isv2={isv2}>
          <Component.C {...props} />
        </Template>
      )
    },
    scope: Component.scope,
  }
}

export default WithTemplate

export interface IMobileScreen {
  mobile?: boolean
  history?: any
}
